<template>
  <img :style="{ objectFit: fit }" :src="src" />
</template>

<script>
export default {
  props: {
    fit: {
      type: String,
      default: 'contain'
    },
    src: {
      type: String,
      required: true
    }
  }
}
</script>


